(() => {
  const setDisabled = (container, disabled) => {
    container.querySelectorAll('input, select, textarea').forEach((field) => {
      field.disabled = disabled;
    });
  };

  const initializeContact = (root) => {
    root.querySelectorAll('.js-fineps-contact').forEach((form) => {
      if (form.dataset.finepsInitialized === 'true') return;
      form.dataset.finepsInitialized = 'true';
      const generalFields = form.querySelector('[data-contact-general]');
      const quoteFields = form.querySelector('[data-contact-quote]');
      const modes = form.querySelectorAll('input[name="fineps-contact-mode"]');

      const updateMode = () => {
        const quoteMode = form.querySelector('input[name="fineps-contact-mode"]:checked').value === 'shipping-quote';
        generalFields.hidden = quoteMode;
        quoteFields.hidden = !quoteMode;
        setDisabled(generalFields, quoteMode);
        setDisabled(quoteFields, !quoteMode);
      };

      modes.forEach((mode) => mode.addEventListener('change', updateMode));
      updateMode();
    });
  };

  const uniqueSorted = (values) => Array.from(new Set(values.filter(Boolean))).sort((a, b) => a.localeCompare(b));

  const setOptions = (select, values, prompt) => {
    select.innerHTML = '';
    const promptOption = document.createElement('option');
    promptOption.value = '';
    promptOption.textContent = prompt;
    select.appendChild(promptOption);
    values.forEach((entry) => {
      const option = document.createElement('option');
      option.value = entry.value;
      option.textContent = entry.label;
      select.appendChild(option);
    });
    select.disabled = values.length === 0;
  };

  const initializeWholesale = (root) => {
    root.querySelectorAll('.js-fineps-wholesale').forEach((form) => {
      if (form.dataset.finepsInitialized === 'true') return;
      form.dataset.finepsInitialized = 'true';
      const catalogElement = form.querySelector('[data-fineps-wholesale-catalog]');
      const rows = form.querySelector('[data-wholesale-rows]');
      const template = form.querySelector('[data-wholesale-row-template]');
      const summary = form.querySelector('[data-wholesale-summary]');
      let catalog = [];

      try {
        catalog = JSON.parse(catalogElement.textContent);
      } catch (error) {
        catalog = [];
      }

      const families = uniqueSorted(catalog.map((item) => item.family));

      const updateSummary = () => {
        const lines = Array.from(rows.querySelectorAll('[data-wholesale-row]')).map((row) => {
          const selected = row.querySelector('[data-wholesale-item]').selectedOptions[0];
          const quantity = row.querySelector('[data-wholesale-quantity]').value;
          return selected && selected.value && quantity ? `${selected.textContent} | Quantity: ${quantity}` : '';
        }).filter(Boolean);
        summary.value = lines.join('\n');
      };

      const addRow = () => {
        const fragment = template.content.cloneNode(true);
        const row = fragment.querySelector('[data-wholesale-row]');
        const familySelect = row.querySelector('[data-wholesale-family]');
        const typeSelect = row.querySelector('[data-wholesale-type]');
        const itemSelect = row.querySelector('[data-wholesale-item]');
        const quantity = row.querySelector('[data-wholesale-quantity]');
        const remove = row.querySelector('[data-wholesale-remove]');

        setOptions(familySelect, families.map((family) => ({ value: family, label: family })), 'Select product family');
        setOptions(typeSelect, [], 'Select product type');
        setOptions(itemSelect, [], 'Select product and variant');

        familySelect.addEventListener('change', () => {
          const types = uniqueSorted(catalog.filter((item) => item.family === familySelect.value).map((item) => item.type));
          setOptions(typeSelect, types.map((type) => ({ value: type, label: type })), 'Select product type');
          setOptions(itemSelect, [], 'Select product and variant');
          updateSummary();
        });

        typeSelect.addEventListener('change', () => {
          const products = catalog.filter((item) => item.family === familySelect.value && item.type === typeSelect.value);
          const options = products.flatMap((item) => item.variants.map((variant) => ({
            value: `${item.handle}:${variant.id}`,
            label: variant.title === 'Default Title' ? item.title : `${item.title} - ${variant.title}`
          })));
          setOptions(itemSelect, options, 'Select product and variant');
          updateSummary();
        });

        itemSelect.addEventListener('change', updateSummary);
        quantity.addEventListener('input', updateSummary);
        remove.addEventListener('click', () => {
          row.remove();
          if (!rows.querySelector('[data-wholesale-row]')) addRow();
          updateSummary();
        });

        rows.appendChild(fragment);
      };

      form.querySelector('[data-wholesale-add]').addEventListener('click', addRow);
      form.addEventListener('submit', updateSummary);
      addRow();
    });
  };

  initializeContact(document);
  initializeWholesale(document);
  document.addEventListener('shopify:section:load', (event) => {
    initializeContact(event.target);
    initializeWholesale(event.target);
  });
})();
